/**
 * 正则
 */
export default {
    // 十进制数字校验正则，整数不允许前导0，小数的整数位只有一位时不用允许多个前导0，整数位有多位时不允许前导0
    reNumber: /^[-+]?(((0|[1-9]\d*)?\.\d+)|(0|[1-9]\d*))$/,             // 数字
    rePositiveNumber: /^[+]?(((0|[1-9]\d*)?\.\d+)|(0|[1-9]\d*))$/,      // 正数
    rePositiveNumberNotZero: /^[+]?(((0|[1-9]\d*)?\.\d+)|([1-9]\d*))$/, // 非0正数
    reNegativeNumber: /^-(((0|[1-9]\d*)?\.\d+)|([1-9]\d*))$/,           // 负数
    reNegativeNumberHasZero: /^0|-(((0|[1-9]\d*)?\.\d+)|([1-9]\d*))$/,  // 包含0的负数
    reInt: /^[-+]?(0|[1-9]\d*)$/,                                       // 整数
    rePositiveInt: /^[+]?(0|[1-9]\d*)$/,                                // 正整数
    rePositiveIntNotZero: /^[+]?([1-9]\d*)$/,                           // 非0正整数
    reNegativeInt: /^-(0|[1-9]\d*)$/,                                   // 负整数
    reNegativeIntHasZero: /^0|-(0|[1-9]\d*)$/,                          // 包含0的负整数
    reEmail: /^[a-zA-Z0-9]+[a-zA-Z0-9_\-.]*@[a-zA-Z0-9]+[a-zA-Z0-9_\-.]*[.][a-zA-Z0-9_\-.]+$/,    // 邮箱
    reChinaMobile: /^\+86\d{11}\b/,                                     // 中国手机号
    reSingaporeMobile: /^\+65\d{8}\b/,                                  // 新加坡手机号
    reImg: /\.(gif|png|jpg|jpeg|wbmp|svg|bmp|ico|tif|tiff|heic|heif|avif|raw|cr2|nef|arw|psd){1}$/i,                            // 匹配img
    reVideo: /\.(mp4|avi|mov|mkv|wmv|flv|webm|m4v|ts|3gp|mpeg|mpg|rm|rmvb|asf|f4v|divx|vob|mts|m2ts|mxf|dv|nsv|tod|mod){1}$/i,                            // 匹配Video
    reDoc: /\.(doc|docx){1}$/i,                                            // 匹配文档
    reExcel: /\.(xls|xlsx){1}$/i,                                       // 匹配表格
    rePDF: /\.(pdf){1}$/i,                                              // 匹配pdf
    rePPT: /\.(ppt|pps|pptx|ppsx){1}$/i,                                // 匹配ppt
}
